import bassIcon from '../components/RoundUp/assets/instrument/bass.svg';
import guitarIcon from '../components/RoundUp/assets/instrument/guitar.svg';
import keyboardIcon from '../components/RoundUp/assets/instrument/keyboard.svg';
import vocalsIcon from '../components/RoundUp/assets/instrument/vocals.svg';
import drumsIcon from '../components/RoundUp/assets/instrument/drums.svg';

import preloadAsset from './AssetUtils';

export const preloadInstrumentAssets = (instrument) => {
  if (instrument === 'vocals') {
    preloadAsset(vocalsIcon);
  }

  if (instrument === 'guitar') {
    preloadAsset(guitarIcon);
  }

  if (instrument === 'drums') {
    preloadAsset(drumsIcon);
  }

  if (instrument === 'keyboard') {
    preloadAsset(keyboardIcon);
  }

  if (instrument === 'bass') {
    preloadAsset(bassIcon);
  }
}

export const kidInstrumentAssets = {
  "bass": bassIcon,
  "drums": drumsIcon,
  "guitar": guitarIcon,
  "keyboard": keyboardIcon,
  "vocals": vocalsIcon
}


export const getFontSize = (text, baseSize = 28, minSize = 22, maxLength = 20) => {
  if (!text) return `${baseSize}px`;
  // eslint-disable-next-line prefer-destructuring
  const length = text.length;
  if (length <= maxLength) return `${baseSize}px`;

  const adjustedSize = Math.max(minSize, baseSize - (length - maxLength) * 0.8);
  return `${adjustedSize}px`;
}

export const colorChoices = {
  1: {
    // dark orange
    assetBackgroundColor: '#EC660D',
    // orange
    backgroundColor: '#F8AB45'
  },
  2: {
    // dark yellow
    assetBackgroundColor: '#EFCB37',
    // yellow
    backgroundColor: '#FFEF77'
  },
  3: {
    // purple
    assetBackgroundColor: '#5F2467',
    // light-purple
    backgroundColor: '#A473AF'
  },
  4: {
    // dark blue
    assetBackgroundColor: '#006DB0',
    // light blue
    backgroundColor: '#10A5E5'
  },
  5: {
    // dark teal
    assetBackgroundColor: '#338988',
    // light teal
    backgroundColor: '#338988'
  }
}
